import {
  ADD_EMPLOYEE_MODE,
  CLEAR_EMPLOYEES,
  CREATE_EMPLOYEE,
  DELETE_EMPLOYEE,
  MOD_EMPLOYEE,
  DELETE_EMPLOYEE_MODE,
  EDIT_EMPLOYEE_MODE,
  EMPLOYEE_SELECTED,
  GET_EMPLOYEES,
  GET_EMPLOYEES_DATA,
  RESET_EMPLOYEE_SELECTED
} from "../../reducers/employeesCatalog/employeesCatalogReducer";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { api_delete, api_get, api_post, api_put } from "../../../services/api";

export const getEmployeesData = () => {
  const url = `${process.env.REACT_APP_URL}/crm/employees/catalogs`;
  let payload = {};
  return async( dispatch ) => {
    dispatch(startRequestComp("loadingEmployees"));

    await api_get(url).then(resp => {
      payload = {
        type: GET_EMPLOYEES_DATA,
        payload: resp
      };
      dispatch(payload);
    }).catch(error => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingEmployees"));
  };
};

export const getEmployees = ( stationID, action = null ) => {
  const url = `${process.env.REACT_APP_URL}/crm/stations/${stationID}/employees`;
  let payload = {};
  return async( dispatch ) => {
    dispatch(startRequestComp("loadingEmployees"));
    await api_get(url).then(resp => {
      payload = {
        type: GET_EMPLOYEES,
        payload: resp.employees
      };
      dispatch(payload);
      action && action();

    }).catch(error => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingEmployees"));
  };
};

export const employeeSelected = (id) => {
  return {
    type: EMPLOYEE_SELECTED,
    payload: id
  };
};

export const addEmployeeMode = () => {
  return {
    type: ADD_EMPLOYEE_MODE,
  };
};

export const editEmployeeMode = () => {
  return {
    type: EDIT_EMPLOYEE_MODE,
  };
};

export const deleteEmployeeMode = () => {
  return {
    type: DELETE_EMPLOYEE_MODE,
  };
};

export const resetEmployeeSelected = () => {
  return {
    type: RESET_EMPLOYEE_SELECTED
  };
};
export const createNewEmployee = (form, action = null) => {
  const url = `${process.env.REACT_APP_URL}/crm/employees`;
  return async ( dispatch ) => {
    dispatch(startRequestComp("loadingEmployeesCrud"));
    await api_post(url, form).then(resp => {
      // Backend no retorna unitNumber en la respuesta, lo añadimos del form para actualizar la UI
      dispatch({ type: CREATE_EMPLOYEE, payload: { ...resp?.employee, unitNumber: resp?.employee?.unitNumber ?? form.unitNumber } });
      dispatch(setSnackbar('El empleado se ha creado con éxito', 'success'));
      action && action();
    }).catch(error => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingEmployeesCrud"));
  };
};

export const editEmployee = (id, form, action = null) => {
  const url = `${process.env.REACT_APP_URL}/crm/employees/${id}`;
  return async ( dispatch ) => {
    dispatch(startRequestComp("loadingEmployeesCrud"));
    await api_put(url, form).then(resp => {
      // Backend no retorna unitNumber en la respuesta, lo añadimos del form para actualizar la UI
      dispatch({ type: MOD_EMPLOYEE, payload: { ...resp.employee, unitNumber: resp?.employee?.unitNumber ?? form.unitNumber } });
      dispatch(setSnackbar('El empleado se ha editado con éxito', 'success'));
      action && action();
    }).catch(error => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingEmployeesCrud"));
  };
};

export const deleteEmployee = (id) => {
  const url = `${process.env.REACT_APP_URL}/crm/employees/${id}`;
  let payload = {};
  return async ( dispatch ) => {
    dispatch(startRequestComp("loadingEmployeesCrud"));
    await api_delete(url).then(() => {
      payload = {
        type: DELETE_EMPLOYEE,
        payload: id
      };
      dispatch(payload);
      dispatch(setSnackbar('El empleado se ha eliminado con éxito', 'success'));
    }).catch(error => {
      dispatch(error);
    });
    dispatch(stopRequestComp("loadingEmployeesCrud"));
  };
};


export const clearEmployees = () => {
  return {
    type: CLEAR_EMPLOYEES,
  };
};